import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import VueTagManager from "vue-gtm";
import GlobalVariables from "./store/globalStateVariables";
import BootstrapVue from "bootstrap-vue";
import VeeValidate from "vee-validate";
import "./assets/scss/application.scss";
import "./components/global/_global";
import ApiService from "./common/api.service";
import VueCookies from "vue-cookies";
Vue.use(VueTagManager, {
  id: ["GTM-MP8RG2T"],
  enabled: true,
});
Vue.use(VueCookies);
Vue.config.productionTip = false;
ApiService.init();
Vue.use(BootstrapVue);
Vue.use(VeeValidate);
new Vue({
  router,
  store,
  GlobalVariables,
  render: (h) => h(App),
}).$mount("#app");
